import { useParams, useSearchParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import PhysicalAndMentalSymptomService from "../../../services/PhysicalAndMentalSymptomService";
import PhysicalAndMentalSymptomEditForm from "./ui/physical-and-mental-symptom-edit-form";
import { PhysicalAndMentalSymptomViewModel } from "../../../viewModels";
import ChildrenSymptomsTable from "./ui/children-symptoms-table";

export default function PhysicalAndMentalSymptomEditPage() {
  const [searchParams] = useSearchParams();

  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<PhysicalAndMentalSymptomViewModel | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const api = new PhysicalAndMentalSymptomService();

  useEffect(() => {
    if (id) {
      api
        .getSymptom(id)
        .then((data) => {
          setItem(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [id, searchParams.get("reload")]);

  if (!loading && !item)
    return (
      <NotFound
        backUrl="/admin/physical-and-mental-symptoms"
        message="Symptom not found."
      ></NotFound>
    );

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Physical & Mental Symptoms", href: "/admin/physical-and-mental-symptoms" },
          {
            label: "Edit",
            href: `/admin/physical-and-mental-symptoms/edit/${id}`,
            active: true,
          },
        ]}
      />
      {loading ? null : null}

      {!loading && item ? (
        <>
          <PhysicalAndMentalSymptomEditForm item={item} />
          <ChildrenSymptomsTable parent={item}></ChildrenSymptomsTable>
        </>
      ) : null}
    </main>
  );
}
